import { getUsers } from 'common/api/v1/users';

import {
    FETCH_USERS,
    FETCH_USERS_FAILURE,
    FETCH_USERS_SUCCESS,
} from '../actionTypes';
import { createContactModalActions } from '../reducer';

export default () => (dispatch) => {
    dispatch(createContactModalActions[FETCH_USERS]());

    getUsers()
        .then((response) =>
            dispatch(
                createContactModalActions[FETCH_USERS_SUCCESS](
                    response.data.data,
                ),
            ),
        )
        .catch((error) =>
            dispatch(
                createContactModalActions[FETCH_USERS_FAILURE](
                    error?.response?.data?.message,
                ),
            ),
        );
};
